import {useNavigate, useSearchParams} from 'react-router-dom';
import {useEffect, useRef, useState} from 'react';
import {apiClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {useBootstrapData} from '@common/core/bootstrap-data/bootstrap-data-context';
import {invalidateBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';
import {setTrackingParametersCookie} from '@common/utils/hooks/use-tracking-parameters';

export function useSudaniRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {data} = useBootstrapData();
  const logSentRef = useRef(false);
  const subscriptionCheckedRef = useRef(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const mdn = searchParams.get('phoneNumber');
    if (!mdn || subscriptionCheckedRef.current) return;
    subscriptionCheckedRef.current = true;
    console.log("🚀🚀🚀 ~ use-sudani-redirect.tsx:20 ~ useSudaniRedirect ~ mdn:", mdn)

    const digits = mdn ? mdn.replace(/\D/g, '') : '';
    const msisdn = digits.length === 8 ? `2491${digits}` : digits;
    const trackingParameters = Object.fromEntries(searchParams.entries());
    const hasTrackingParams = Object.keys(trackingParameters).length > 0;
    const conversionUrl = data?.environment?.CONVERSION_URL;
    const conversionLoggerUrl = conversionUrl
      ? conversionUrl.endsWith('/')
        ? `${conversionUrl}logger`
        : `${conversionUrl}/logger`
      : undefined;

    if (!msisdn) return;

    if (hasTrackingParams && searchParams.get('gclid')) {
      setTrackingParametersCookie(trackingParameters);
    }
    if (conversionLoggerUrl && !logSentRef.current) {
      logSentRef.current = true;
      const allParams = Object.fromEntries(searchParams.entries());
      fetch(conversionLoggerUrl, {
        method: 'POST',
        body: JSON.stringify(allParams),
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }

    setLoading(true);
    navigate('/', {replace: true});

    (async () => {
      try {
        const response = await apiClient.post(
          'billing/sudani/sync-subscription-details',
          {
            phone: msisdn,
            tracking_parameters: hasTrackingParams
              ? trackingParameters
              : undefined,
          },
        );
        // an ended subscription comes back too: only an active one is news
        if (response.data.is_active) {
          toast(message('Subscription activated successfully'));
        } else {
          toast.danger(
            message('No active Sudani subscription was found for this number.'),
          );
        }
        // the visitor is now signed in to this number's account either way
        invalidateBootstrapData();
      } catch (err: any) {
        if (err?.response?.data?.error?.message) {
          toast.danger(err.response.data.error.message);
          invalidateBootstrapData();
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [data?.environment?.CONVERSION_URL, navigate, searchParams]);

  return loading;
}
